import { render, staticRenderFns } from "./TextPanel.vue?vue&type=template&id=3853ed7e&scoped=true&"
import script from "./TextPanel.vue?vue&type=script&lang=js&"
export * from "./TextPanel.vue?vue&type=script&lang=js&"
import style0 from "./TextPanel.vue?vue&type=style&index=0&id=3853ed7e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../morphology/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3853ed7e",
  null
  
)

export default component.exports